import { gql } from '@apollo/client';

const PRODUCT_CURRICULUM_FRAGMENT = gql`
  fragment BaseProductCurriculum on ProductCurriculum {
    id
    code
    name
    gradeLevel
    trialAvailable
    iconUrl
    bannerUrl
    productId
  }
`;

export default PRODUCT_CURRICULUM_FRAGMENT;
